import React from 'react';
import { clsx } from 'clsx';
import { TableRow } from './TableRow';
import { TableCell } from './TableCell';

interface TableEmptyProps {
  colSpan: number;
  children: React.ReactNode;
  className?: string;
}

export function TableEmpty({ colSpan, children, className }: TableEmptyProps) {
  return (
    <TableRow>
      <TableCell 
        colSpan={colSpan}
        className={clsx("text-center text-gray-500", className)}
      >
        {children}
      </TableCell>
    </TableRow>
  );
} 